import { HttpResponse } from '@angular/common/http';
import { from, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { GenerateZipTimeEstimate } from '@models/files/zip-estimate.model';

/**
 * A 202 response means the zip is too large to build inline: the body is a JSON `GenerateZipTimeEstimate`
 * instead of the usual blob, but the request still used `responseType: 'blob'` to support the direct-download case.
 */
export function parseZipDownloadResponse(
  response: HttpResponse<Blob>,
): Observable<HttpResponse<Blob> | GenerateZipTimeEstimate> {
  if (response.status !== 202 || !response.body) {
    return of(response);
  }
  return from(response.body.text()).pipe(map(text => JSON.parse(text) as GenerateZipTimeEstimate));
}
